import React from "react";
import { MarketingPage } from "@/pages/ForFamilies";

export default function ForAgencies() {
  return (
    <MarketingPage
      testID="for-agencies"
      seo={{ title: "Partner agency network", path: "/for-agencies", description: "Join the HomecareMatches partner network. We verify your credentials, then send you pre-matched families — no lead chasing, plus a fair dispute SLA and monthly scorecards." }}
      eyebrow="FOR PARTNER AGENCIES"
      title="Pre-matched families, delivered to your inbox."
      blurb="Join the HomecareMatches partner network. We verify your credentials, then send you families already matched to your caregivers' skills and availability — you focus on delivering great care."
      primaryCta={{ label: "Partner with us", icon: "briefcase", route: "/agency-apply" }}
      features={[
        { icon: "user-check", title: "Pre-matched families", desc: "No lead chasing. We approve the match and send a non-clinical hand-off with everything you need." },
        { icon: "shield", title: "Simple vetting", desc: "License, insurance, background-check standard and complaint history — four checks and you're in the pool." },
        { icon: "users", title: "Manage caregivers", desc: "Maintain caregiver profiles, availability and eligibility so staff only assign who's truly ready." },
        { icon: "check-square", title: "Day-1 checklist", desc: "Record a simple pass/fail nurse checklist. Clinical detail stays in your own systems." },
        { icon: "bar-chart-2", title: "Performance scorecard", desc: "See your disputes, Day-1 mismatch rate and follow-up pass rate — emailed monthly." },
        { icon: "alert-circle", title: "Fair dispute SLA", desc: "Every concern gets a clear 5-business-day clock with a simple inbox to respond and resolve." },
      ]}
    />
  );
}
